import { getConfig } from "@/lib/config";

// Build the `/auth/login?next=…` URL that the BFF accepts. The `next`
// query is sanitized by safeNextPath on the BFF (must be an in-app
// path), so any open-redirect concern lives there; here we only have
// to pass through the current location so post-login navigation lands
// where the user was trying to go.

// `silent` asks the BFF for a prompt=none recovery attempt instead of an
// interactive login: no form is ever shown, and if Keycloak's SSO session is
// gone it bounces us into a normal login for the same target. See
// auth/session-watch.ts for when that is worth trying.
export function loginUrlFor(pathAndSearch: string, options: { silent?: boolean } = {}): string {
  const cfg = getConfig();
  const url = `${cfg.basePath}auth/login?next=${encodeURIComponent(pathAndSearch)}`;
  return options.silent ? `${url}&silent=1` : url;
}
